import styled, { withTheme } from 'styled-components';
// import bp from '@bootstrap-styled/css-mixins/lib/breakpoints';

const Style = styled.div`
    padding:30px;
    background: ${(props) => props.theme.$contrast};

`;

export default withTheme(Style);
